const mountSourceButton = (editor, onToggle, startActive = false, attempt = 0) => {
  const toolbarElement = editor?.ui?.view?.toolbar?.element;
  const toolbarItems = toolbarElement?.querySelector(".ck-toolbar__items");

  if (!toolbarItems) {
    if (attempt < 20) {
      window.requestAnimationFrame(() =>
        mountSourceButton(editor, onToggle, startActive, attempt + 1)
      );
    }
    return null;
  }

  if (toolbarItems.querySelector("[data-mail-source-btn]")) {
    return toolbarItems.querySelector("[data-mail-source-btn]");
  }

  const button = document.createElement("button");
  button.type = "button";
  button.setAttribute("data-mail-source-btn", "true");
  button.className = `ck ck-button ${
    startActive ? "ck-on" : "ck-off"
  } mail-template-source-toolbar-btn`;
  button.setAttribute("aria-label", "Source");
  button.setAttribute("data-cke-tooltip-text", "Source");

  const glyph = document.createElement("span");
  glyph.className = "mail-template-source-glyph";
  glyph.setAttribute("aria-hidden", "true");
  glyph.textContent = "<>";
  button.appendChild(glyph);

  const separator = document.createElement("span");
  separator.className = "ck ck-toolbar__separator";
  separator.setAttribute("data-mail-source-separator", "true");

  button.addEventListener("click", (event) => {
    event.preventDefault();
    const enteringSource = !button.classList.contains("ck-on");
    button.classList.toggle("ck-on", enteringSource);
    button.classList.toggle("ck-off", !enteringSource);
    if (typeof onToggle === "function") {
      onToggle(enteringSource, editor);
    }
  });

  toolbarItems.insertBefore(separator, toolbarItems.firstChild);
  toolbarItems.insertBefore(button, toolbarItems.firstChild);

  return button;
};

/** Adds a Source button to the existing ClassicEditor toolbar (no extra CKEditor packages). */
export const registerMailTemplateSourceToolbarButton = (
  editor,
  onToggle,
  startActive = false
) => mountSourceButton(editor, onToggle, startActive);
